import { render, staticRenderFns } from "./createSubsidy.vue?vue&type=template&id=d6b3ab8a&scoped=true"
import script from "./createSubsidy.vue?vue&type=script&lang=js"
export * from "./createSubsidy.vue?vue&type=script&lang=js"
import style0 from "./createSubsidy.vue?vue&type=style&index=0&id=d6b3ab8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b3ab8a",
  null
  
)

export default component.exports